import { GOOGLE_TAG_MANAGER_DATA_LAYER_NAME } from '../consts/defaultConfigValues/defaultConstants'
import { GTMEventNames, GTMEventParams } from '../interfaces/tag_manager'

export const fireGTMEvent = <T extends GTMEventNames>(
  eventName: `${T}`,
  data: GTMEventParams[T],
): void => {
  const dataLayer = (window as any)[GOOGLE_TAG_MANAGER_DATA_LAYER_NAME]
  if (Array.isArray(dataLayer)) {
    dataLayer.push({
      event: eventName,
      ...data,
    })
  }
}
